import React from 'react';
import { NJIcon, NJToastContainer } from '@engie-group/fluid-design-system-react';
import { useState, useEffect, useCallback } from 'react';
import { Flex, Table } from "antd";
import './AdminFeedback.css';
import { apiGatewayConfig } from '../../../config';
import { displayNetworkError, invokeLambda } from '../../../api';
import { useOktaAuth } from "@okta/okta-react";
import { useUser } from '../../../context/UserContext';
import Loading from '../../../Loading';

const AdminFeedback = ({ active }) => {
    const userInfo = useUser();
    const { oktaAuth } = useOktaAuth();

    const [dataset, setDataset] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [positiveCount, setPositiveCount] = useState(0);
    const [negativeCount, setNegativeCount] = useState(0);

    const feedbackColumns = [
        {
            title: 'Date',
            dataIndex: 'timestamp',
            key: 'timestamp',
            width: 190,
            render: (text) => text ? new Date(text).toLocaleString() : '-'
        },
        {
            title: 'Comment',
            dataIndex: 'comment',
            key: 'comment'
        }
    ];

    const handleLoadDataset = useCallback(async () => {
        // Prepare request
        const request = {
            feedback: 'Compute',
        };
        setIsLoading(true);
        try {
            const response = await invokeLambda(oktaAuth, apiGatewayConfig.endpointJagFeedback, request, userInfo);
            if (response && response.items) {
                setDataset(response.items);
                setPositiveCount(response.up_count || 0);
                setNegativeCount(response.down_count || 0);
            }
        } catch (error) {
            console.error('Error loading feedback data:', error);
            displayNetworkError(error);
        } finally {
            setIsLoading(false);
        }
    }, [oktaAuth, userInfo]);

    useEffect(() => {
        if (active) {
            handleLoadDataset();
        }
    }, [active, handleLoadDataset]);

    return (
        <>
            {isLoading && <Loading text="Loading feedback data..." />}
            <NJToastContainer type="full-width" />
            <div className='admin-data-content'>
                <div className='admin-feedback-count'>
                    <Flex gap={64} align='center' justify='center'>
                        <Flex align='center'>
                            <span className="admin-feedback-number">{positiveCount}</span>
                            <NJIcon
                                name="thumb_up_off_alt"
                                size="lg"
                            />
                        </Flex>
                        <Flex align='center'>
                            <span className="admin-feedback-number">{negativeCount}</span>
                            <NJIcon
                                name="thumb_down_off_alt"
                                size="lg"
                            />
                        </Flex>
                    </Flex>
                </div>
                <div className='admin-data-grey-box'>
                    <div className='admin-data-table'>
                        <Table
                            dataSource={dataset}
                            rowKey={(record) => record.id || Math.random().toString()}
                            pagination={false}
                            columns={feedbackColumns}
                            sticky={{
                                offsetHeader: 0,
                            }}
                            expandable={{
                                expandedRowRender: (record) => <>
                                    <div>
                                        <textarea
                                            className='admin-feedback-expanded-job-description'
                                            value={record.job_description}
                                            readOnly
                                        />
                                    </div>
                                    <div>
                                        <textarea
                                            className='admin-feedback-expanded-job-ad'
                                            value={record.job_ad}
                                            readOnly
                                        />
                                    </div>
                                </>,
                                rowExpandable: (record) => true,
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminFeedback;
